<template>
  <div
    class="bg"
    v-loading="loading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="title"></div>
    <div class="box">
      <div class="pannel" v-show="pageState === 'register'">
        <el-form class="login-form" ref="loginForm" :rules="rules2" label-width="0px" :model="userInfo">
          <div class="sub-title">您好，欢迎注册</div>
          <el-form-item prop="phone">
            <el-input v-model="userInfo.phone" placeholder="请输入手机号码">
              <i class="el-icon-user login-icon" slot="prefix"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="pwd">
            <el-input type="password" v-model="userInfo.pwd" placeholder="请输入密码">
              <i class="el-icon-lock login-icon" slot="prefix"></i>
            </el-input>
          </el-form-item>
          <el-button type="primary" size="small" class="submit-btn" @click="doRegister">注册</el-button>
        </el-form>
      </div>
      <div class="pannel" v-show="pageState === 'bind'">
        <el-form class="login-form" ref="loginForm" :rules="rules2" label-width="0px" :model="userInfo">
          <div class="sub-title">您好，欢迎注册</div>
          <el-form-item prop="phone">
            <el-input v-model="userInfo.phone" placeholder="请输入手机号码">
              <i class="el-icon-user login-icon" slot="prefix"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="pwd">
            <el-input type="password" v-model="userInfo.pwd" placeholder="请输入密码">
              <i class="el-icon-lock login-icon" slot="prefix"></i>
            </el-input>
          </el-form-item>
          <el-button type="primary" size="small" class="submit-btn" @click="doRegister">注册</el-button>
        </el-form>
      </div>
    </div>
    <div class="footer text-center">
      推荐使用谷歌浏览器，谷歌浏览器下载地址
      <a href="https://www.google.cn/intl/zh-CN/chrome/" target="_blank"
        >&nbsp;&nbsp;&nbsp;&nbsp;https://www.google.cn/intl/zh-CN/chrome/</a
      >
      <div style="width:400px;margin:0 auto; padding:10px 0;">
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32050702010954"
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
        >
          <img src="../assets/img/logo.png" style="float:left;" />
          <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">
            苏公网安备 32050702010954号
          </p>
        </a>
        <a
          target="_blank"
          href="https://beian.miit.gov.cn/"
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
        >
          <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 15px; color:#939393;">
            &nbsp; &nbsp;苏ICP备2021004150号
          </p>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
// import Identify from '@/components/Identify'
// import md5 from 'js-md5' // md5加密

export default {
  name: 'login',
  components: {
    // Identify
  },
  data() {
    const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    return {
      params: {},
      userInfo: {
        xm: '',
        sfzmhm: '',
        yzm: '',
        phone: '',
        pwd: '',
        pwd2: ''
      },
      identifyCodes: '0123456789ABCDEFGHJKLMNPQRSTUVWXYZ',
      identifyCode: '',
      canvasW: (height * 0.352 * 5) / 12,
      canvasH: height * 0.055,
      pic: '',
      codeToken: '',
      pageState: 'register',
      // 表单验证
      rules2: {
        phone: [{ required: true, message: '请输入手机号码', trigger: 'blur' }],
        pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        pwd2: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(rule.msg)
              } else if (this.userInfo.pwd !== this.userInfo.pwd2) {
                callback('两次输入密码不一致')
              } else {
                callback()
              }
            },
            msg: '请确认密码',
            trigger: 'blur'
          }
        ]
      },
      loading: false
    }
  },
  methods: {
    // 解析页面URL
    getUrlParam(url) {
      var paramStr = url.substring(url.indexOf('?') + 1, url.length).split('&')
      var j
      var paramObj = {}
      for (var i = 0; (j = paramStr[i]); i++) {
        console.log(i)
        paramObj[j.substring(0, j.indexOf('='))] = j.substring(j.indexOf('=') + 1, j.length)
      }
      var returnValue = paramObj
      if (typeof returnValue === 'undefined') {
        return ''
      } else {
        return returnValue
      }
    },
    // 注册
    doRegister() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.checkPhone()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 检查手机号码
    checkPhone() {
      const params = {
        phone: this.userInfo.phone,
        pwd: this.userInfo.pwd
      }
      this.loading = true
      this.$post('/flowPlatformUser/checkPhone', params)
        .then(response => {
          this.loading = false
          if (response.status === 200) {
            this.register()
          } else {
            this.$root.$children[0].vueAlert({ message: response.status + ':' + response.msg, type: 'error' })
          }
        })
        .catch(err => {
          console.log(err)
          this.loading = false
          this.$root.$children[0].vueAlert({ message: '请求失败，请联系管理员！', type: 'error' })
        })
    },
    register() {
      const params = {
        phone: this.userInfo.phone,
        pwd: this.userInfo.pwd,
        code: this.params.code
      }
      this.loading = true
      this.$post('/flowPlatformUser/wechatRegister', params)
        .then(response => {
          this.loading = false
          if (response.status === 200) {
            this.$root.$children[0].vueAlert({ message: response.msg, type: 'success' }, () => {
              window.location.href = 'http://17l.link/dist/?id=1&targetName=LoginFlow&wechatLogin=true&state=123'
            })
          } else if (response.status === -2) {
            this.$root.$children[0].vueAlert({ message: response.status + ':' + response.msg, type: 'warning' }, () => {
              window.location.href = 'http://17l.link/dist/?id=1&targetName=LoginFlow&wechatLogin=true&state=123'
            })
          } else if (response.status === 0) {
            this.$root.$children[0].vueAlert({ message: response.status + ':' + response.msg, type: 'warning' }, () => {
              window.location.href = 'http://17l.link/dist/?id=1&targetName=LoginBindFlow&wechatLogin=true&state=123'
            })
          } else {
            this.$root.$children[0].vueAlert({ message: response.status + ':' + response.msg, type: 'error' })
          }
        })
        .catch(err => {
          console.log(err)
          this.loading = false
          this.$root.$children[0].vueAlert({ message: '请求失败，请联系管理员！', type: 'error' })
        })
    }
  },
  mounted() {
    this.params = this.getUrlParam(window.location.href)
    this.$root.$children[0].sign('http://17l.link/dist/#/login')
    this.$common.storage.clear()
  },
  created() {},
  beforeDestroy() {}
}
</script>

<style lang="less">
.text-center {
  text-align: center;
}
.el-input__prefix {
  height: 5vh;
  min-height: 40px;
}
.pannel .el-input--prefix .el-input__inner {
  padding-left: 50px;
}
.pannel .el-form-item__content {
  height: 40px;
}
</style>
<style lang="less" scoped>
.bg {
  background: #1e1e1e;
  background-size: cover;
  height: auto;
  min-height: 100vh;
  width: 100%;
  .title {
    margin: 0 auto;
    padding: 4.5vh 0 0 0;
    padding-left: (12/1.6) + vw;
    width: 78.6vw;
    color: #fff;
    font-size: 2.2rem;
    font-family: '黑体';
    font-weight: bold;
    text-align: center;
  }
  // 表单标题
  .sub-title {
    margin-bottom: 8vh;
    font-size: 2rem;
    font-weight: bold;
    text-align: center;
    color: #fff;
  }
  // 表单框
  .box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 100;
    margin: 0 auto;
    width: 78.6vw;
    height: 90vh;
    min-height: 510px;
    .pannel {
      display: flex;
      justify-content: center;
      box-sizing: border-box;
      margin: 2vh 2vw 10vh;
      width: 100%;
      .login-form {
        margin: 0 auto;
        width: 35.2vh;
        min-width: 300px;
        .login-icon {
          margin: 8px;
          height: 2rem;
          font-size: 2rem;
        }
      }
      .link {
        float: right;
        color: #fff;
        text-decoration: underline;
        font-size: 16px;
      }
      .submit-btn {
        margin: 10px auto;
        width: 100%;
        height: 6vh;
        border: none;
        background: linear-gradient(90deg, #333 0%, #444 100%);
        border-radius: 1vh;
        font-size: 1.5rem;
        line-height: 5px;
      }
    }
  }
  .footer {
    width: 100%;
    position: fixed;
    bottom: 0;
    color: #fff;
    font-size: 13px;
    font-weight: bold;
    a {
      color: #409eff;
    }
    a:hover {
      text-decoration: underline;
    }
  }
}
</style>
